import React from "react";

import {ClientProviderPreference} from "../../domains";

type Prop = {
    isReturned: boolean;
    isMatched: boolean;
    isDeclinedFromTransfer?: boolean;
    preferences: ClientProviderPreference[];
};

export function ProviderOfferDetailItemBanners ({ isReturned, isMatched, isDeclinedFromTransfer = false, preferences }: Prop) {
    const isPreferred = preferences.length > 0;
    const shouldShowBanners = isMatched || isReturned || isPreferred;

    if (!shouldShowBanners) {
        return null;
    }
    if (isDeclinedFromTransfer) {
        return (
            <div className="relative text-xs text-white placement-provider-offer-detail-item-banner mr-5">
                <span className='mr-1 py-1 px-4 bg-red-600 text-white text-xs placement-provider-offer-detail-item-banner-text'>
                    Declined from Returned/Transfer Request
                </span>
            </div>
        );
    }

    return (
        <div className="relative text-xs text-white placement-provider-offer-detail-item-banner mr-5 z-40">
            {
                (isMatched && !isReturned) && (
                    <span className='mr-1 py-1 px-4 bg-atlantis-200 text-white text-xs placement-provider-offer-detail-item-banner-text'>
                        Matched
                    </span>
                )
            }
            {
                isReturned && (
                    <span className='mr-1 py-1 px-4 bg-red-600 text-white text-xs placement-provider-offer-detail-item-banner-text'>
                        Returned
                    </span>
                )
            }
            {
                isPreferred && preferences.map((preference, index) => (
                    <span key={index} className='mr-1 py-1 px-4 bg-indigo-500 text-white text-xs placement-provider-offer-detail-item-banner-text'>
                        {preference!.preferenceReason || 'Preferred'}
                    </span>
                ))
            }
        </div>
    );
}
